import { sha256Hex } from "utils/crypto";

export const logPaypairConsentEvents = async ({
  logEvent,
  phone,
  smsMarketingConsent,
}) => {
  try {
    logEvent({ name: "click_aff_tcpa_agreement", payload: { isChecked: false } });

    if (!phone) {
      return;
    }

    const phoneHash = await sha256Hex(phone);
    if (!phoneHash) {
      return;
    }

    logEvent({
      name: "paypair_phone_captured",
      payload: {
        customerPhoneSha: phoneHash,
        smsMarketingConsent: smsMarketingConsent,
      },
    });
  } catch (_error) {
    // Analytics should never block the checkout flow.
  }
};
